import { SavedSubaccountSigningPreference } from 'client/modules/singleSignatureSessions/types';
import { UpdateSigningPreferenceFn } from './types';

/**
 * Pure function that derives the SavedSubaccountSigningPreference from an update request.
 * Extracted for testability.
 */
export function getSigningPreferenceToSave(
  newValue: Parameters<UpdateSigningPreferenceFn>[0],
): SavedSubaccountSigningPreference {
  if (newValue.type === 'sign_always') {
    return { type: 'sign_always' };
  }

  return {
    type: 'sign_once',
    rememberMe: newValue.rememberMe,
    // Always save the private key so the linked signer survives re-renders.
    // rememberMe controls whether the key persists across page reloads
    // (handled by LinkedSignerSync on initial load).
    privateKey: newValue.linkedSigner?.privateKey,
  };
}
